import { inject, Injectable } from '@angular/core';
import { AdDirective } from '@goatsports/shared/util';
import { clearViewContainerRef } from '../../shared/functions/clear-view-container-ref';
import { OrganizationSwitchDialogComponent } from './organization-switch-dialog.component';
import { OrganizationAdminOrganizationsStore } from './organization-admin-organizations.store';

@Injectable({ providedIn: 'root' })
export class OrganizationSwitchDialogService {
  private readonly store = inject(OrganizationAdminOrganizationsStore);

  open(adHost: AdDirective) {
    const viewContainerRef = clearViewContainerRef(adHost);
    const componentRef =
      viewContainerRef.createComponent<OrganizationSwitchDialogComponent>(
        OrganizationSwitchDialogComponent,
      );

    // Ensure data is fresh when opening
    this.store.loadOrganizationsForCurrentAdmin();

    componentRef.instance.onClose.subscribe(() => {
      viewContainerRef.clear();
    });
    return componentRef.instance;
  }
}
